import React, { useState } from 'react'
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, TextField, FormControl, InputLabel,Select, MenuItem, Box} from '@mui/material'
import { Controller, useForm } from 'react-hook-form'
import { useSelector } from 'react-redux';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT

function BookDemoPopup({open, onClose, courseId, testTypeId, trainerId, trainerName, deliveryMode, testTypeName, className}) {
    const studentId = localStorage.getItem('studentId');
    const { formState: { errors }, register, control, watch} = useForm();
    const { firstName, lastName, email, role} = useSelector((state) => state.user);
    //const useremail = localStorage.getItem('email')
    const [name, setName] = useState(firstName)
    const [useremail, setUserEmail] = useState(email)
    const [testType, setTestType] = useState('')
    const [classId, setClassId] = useState(courseId)
    const [testDate, setTestDate] = useState('')
    const [previousExperience, setPreviousExperience] = useState('')
    const [demoDate, setDemoDate] = useState('')

    const handleClose = () => {
        onClose()
    }

    const handleDemoSubmit = async () => {
      try {
      const data = {
        student_id: parseInt(studentId),
        test_type_id: testTypeId,
        class_id: courseId,
        delivery_mode: deliveryMode,
        available_demo_date: demoDate,
        trainer_id: trainerId,
      };
    
      // Check if demoDate is an empty string
      if (demoDate === "") {
        const today = new Date();
        const formattedDate = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
        data.available_demo_date = formattedDate;
      } else {
        data.available_demo_date = demoDate;
      }
  
    
      const response = await fetch(`${API_ENDPOINT}studentdashboard/bookdemo`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });

    
      if (response) {
        if (response.status === 200) {
          //const responseData = await response.json();
          const alertMessage = `Status: 200\nMessage: Demo request is created successfully!!`;
          alert(alertMessage);
          onClose();
        } else if (response.status === 404) {
         // const responseData = await response.json();
          const alertMessage = `Status: 404\nMessage: Demo exists for this student!!`;
          alert(alertMessage);
        } else if (response.status === 403) {
         // const responseData = await response.json();
          const alertMessage = `Status: 403\nMessage: Can't book demo because today is Sunday!!`;
          alert(alertMessage);
        } else if (response.status === 400) {
          //const responseData = await response.json();
          const alertMessage = `Status: 400\nMessage: Can't book more demo for today, Please contact our advisor!!`;
          alert(alertMessage);
        } else {
          const dynamicErrorCode = response.status;
          const dynamicErrorMessage = "Unexpected response from the server";
          const alertMessage = `Status: ${dynamicErrorCode}\nMessage: ${dynamicErrorMessage}`;
          alert(alertMessage);
        }
      } else {
        console.error("Empty or undefined response");
        alert('Network Error');
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
    

  return (
    <div className="bookDemo">
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Book Class Demo</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Enter this details to request a demo
          </DialogContentText>
        {/*}  <TextField
            autoFocus
            margin="dense"
            label="Full Name"
            type="text"
            fullWidth
            value={name}
            onChange={(e) => setName(e.target.value)}
        />
    <TextField
      autoFocus
      margin="dense"
      label="User Email"
      type="email"
      fullWidth
      value={useremail}
    />
  <FormControl fullWidth>
    <InputLabel htmlFor='testType' id="test-type-label">Test Type</InputLabel>
      <Controller 
        name="test_type"
        control={control}
        defaultValue=''
        rules={{ required: "Test Type is required" }}
        render={({ field }) => (
          <Select
            labelId="test-type-label"
            id="test-type"
            value={testType}
            {...field}
            //label="Test Type"
            variant="outlined"
            error={!!errors.testType}
           // onChange={(e) => setTestType(e.target.value)}
            fullWidth
          >
            <MenuItem value="IELTS">IELTS</MenuItem>
            <MenuItem value="TOEFL">TOEFL</MenuItem>
            <MenuItem value="GMAT">GMAT</MenuItem>
            <MenuItem value="GRE">GRE</MenuItem>
            <MenuItem value="PTE">PTE</MenuItem>
          </Select>
        )}
      ></Controller>
      </FormControl>
    <TextField
      label="Class ID"
      name="classId"
      value={classId}
      fullWidth
      margin="normal"
        /> */}
      <TextField
      autoFocus
      margin="dense"
      label="Test Type"
      fullWidth
      value={testTypeName}
    />
    <TextField
      autoFocus
      margin="dense"
      label="Class Name"
      fullWidth
      value={className}
    />
      <TextField
      autoFocus
      margin="dense"
      label="Trainer Name"
      fullWidth
      value={trainerName}
    />
     <TextField
      label="Preferred Demo Date"
      name="preferredDemoDate"
      value={demoDate}
      onChange={(e) => setDemoDate(e.target.value)}
      fullWidth
      margin="normal"
      type="date"
      InputLabelProps={{
        shrink: true,
      }}
    />
  {/*}  <TextField
      label="Tentative Exam Date"
      name="preferredDate"
      defaultValue={Date.now()}
      value={testDate}
      onChange={(e) => setTestDate(e.target.value)}
      fullWidth
      margin="normal"
      type="date"
      InputLabelProps={{
        shrink: true,
      }}
    />

      <FormControl fullWidth>
          <InputLabel htmlFor="hasTakenTest" id='taken-test-label'>Have you taken this test before?</InputLabel>
          <Controller
            name="hasTakenTest"
            control={control}
            defaultValue="no"
            render={({ field }) => (
              <Select
                labelId='taken-test-label'
                label="Have you taken this test before?"
                fullWidth
                {...field}
                value={previousExperience}
                onChange={(e) => setPreviousExperience(e.target.value)}
              >
                <MenuItem value="beginner">No, I am a beginner</MenuItem>
                <MenuItem value="prepared">No, but I am prepared</MenuItem>
                <MenuItem value="retake">Yes, I am taking a retake</MenuItem>
              </Select>
            )}
          />
            </FormControl> */}
    <Box mt={2} display="flex" justifyContent="flex-end">
      <Button variant="contained" color="primary" onClick={handleDemoSubmit}>
        Submit
      </Button>
      <Button  color="primary" onClick={handleClose}>
        Close
      </Button>
    </Box>
    </DialogContent>
      </Dialog>
    </div>
  )
}

export default BookDemoPopup